import { memo } from 'react';
import { useNavigate } from 'react-router';
import ActionCard from '../../../components/Assets/ActionCard';
import SectionTitle from '../../../components/Assets/sectionTitle';
import IndividualCircularLoader from '../../../components/Loader/IndividualCircularLoader';
import useFolders from '../useFolders';

const DashboardFolderBloc = () => {
  const { folders, foldersStatusPending } = useFolders({});
  const navigate = useNavigate();

  const handleClickFoldersDetails = (folder: IFolder) => {
    navigate(`/details-dossier/${folder.id}`);
  };

  return (
    <section className="dashboard-section">
      <SectionTitle
        mainTitle="Dossiers de prospection"
        subTitle="Vos annonces en cours d’analyse..."
      />
      {foldersStatusPending ? (
        <IndividualCircularLoader size={100} />
      ) : (
        <div className="dashboard-section-content">
          {folders.result
            ?.filter((f) => Boolean(f.totalNewAdStudies))
            ?.map((elt) => (
              <ActionCard
                key={elt.idIri}
                cardType="prospection"
                cardTitle={elt.name}
                cardInfo={elt.totalAdStudies}
                cardUpdates={elt.totalNewAdStudies}
                cardState="filled"
                handleClick={() => handleClickFoldersDetails(elt)}
              />
            ))}
          <ActionCard
            cardTitle="Créez de nouveaux dossiers de prospection"
            cardState=""
            linkTo="/mes-dossiers-creation"
          />
        </div>
      )}
    </section>
  );
};

export default memo(DashboardFolderBloc);
